import React, { useEffect, useState } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getProductionOrderWarehouses } from "../../../../services/production/productionService";

function SearchProductionOrderWarehouse({
  productionOrderID = 0,
  onSelectWarehouse,
}) {
  const [warehouses, setWarehouses] = useState();
  const getProductionOrderWarehouseData = async (productionOrderID = 0) => {
    const response = await getProductionOrderWarehouses(productionOrderID);
    const { data } = response.data;
    setWarehouses(data.warehouses);
  };
  useEffect(() => {
    getProductionOrderWarehouseData(productionOrderID);
  }, [productionOrderID]);
  return (
    <React.Fragment>
      <CustomDataTableSearch
        data={warehouses}
        onRefreshData={() => {}}
        onSelectedData={(rowData, originalEvent) => {
          onSelectWarehouse(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectWarehouse(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Warehouse ID",
            field: "ID",
            body: null,
            sortable: true,
          },
          {
            header: "Warehouse",
            field: "warehouseName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.warehouseName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
        ]}
      />
    </React.Fragment>
  );
}

export default SearchProductionOrderWarehouse;
